import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";
import { ThemeProvider } from "@material-tailwind/react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// All backend routes are under /v1 — point axios there globally
axios.defaults.baseURL = '/v1';

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
